<template>
  <header class="js-header">
    <div class="top-bar">
      <div class="logo-box">
        <a href="/">
          <img :src="logoUrl" />
        </a>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "headerBar",
  data() {
    return {
      logoUrl: process.env.BASE_URL + "img/guestLogo.png"
    };
  },
  props: {},
  created() {},
  methods: {
  }
};
</script>

<style scoped>
header {
  position: relative;
}
.top-bar {
  height: 45px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}


.logo-box {
  position: absolute;
  left: 35%;
  margin-top: 0.375rem;
}

.logo-box img {
  width: 110px;
}

img {
  object-fit: cover;
  vertical-align: top;
}

</style>